/**
 * Created by andrey on 08.08.2025
 */

cc.MoveBy = function (duration, deltaPos, deltaY) {
    cc.ActionInterval.prototype.constructor.call(this);

    this._positionDelta = cc.p(0, 0);
    this._startPosition = cc.p(0, 0);
    this._previousPosition = cc.p(0, 0);

    if (deltaPos !== undefined) {
        this.initWithDuration(duration, deltaPos, deltaY);
    }
};

cc.MoveBy.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.MoveBy,

    initWithDuration: function (duration, position, y) {
        if (cc.ActionInterval.prototype.initWithDuration.call(this, duration)) {
            if (position.x !== undefined) {
                y = position.y;
                position = position.x;
            }

            this._positionDelta.x = position;
            this._positionDelta.y = y;
            return true;
        }
        return false;
    },

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);
        const locPosX = target.getPositionX();
        const locPosY = target.getPositionY();
        this._previousPosition.x = locPosX;
        this._previousPosition.y = locPosY;
        this._startPosition.x = locPosX;
        this._startPosition.y = locPosY;
    },

    update: function (dt) {
        dt = this._computeEaseTime(dt);
        if (this.target) {
            let x = this._positionDelta.x * dt;
            let y = this._positionDelta.y * dt;
            const locStartPosition = this._startPosition;
            if (cc.ENABLE_STACKABLE_ACTIONS) {
                const targetX = this.target.getPositionX();
                const targetY = this.target.getPositionY();
                const locPreviousPosition = this._previousPosition;

                locStartPosition.x = locStartPosition.x + targetX - locPreviousPosition.x;
                locStartPosition.y = locStartPosition.y + targetY - locPreviousPosition.y;
                x += locStartPosition.x;
                y += locStartPosition.y;
                locPreviousPosition.x = x;
                locPreviousPosition.y = y;
                this.target.setPosition(x, y);
            } else {
                this.target.setPosition(locStartPosition.x + x, locStartPosition.y + y);
            }
        }
    }
});

cc.moveBy = (duration, deltaPos, deltaY) => new cc.MoveBy(duration, deltaPos, deltaY);